import ColFormItemWrapper from "./ColWFormItemWrapper";
import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Select,
  Slider,
  Space,
  Switch,
} from "antd";
import { currencyFormatter } from "./form.utils";
import SelectAddItem from "./SelectAddItem";
import SelectFieldAxios from "../../container/SelectFieldAxios";
import AddressForm from "./AddressForm";
import React from "react";
import AutoCompleteCustom from "../AutoCompleteCustom";
import dayjs, { generalFormatAntd, tz } from "../../../utils/dayjs";
import frFR from "antd/es/date-picker/locale/fr_FR";
import { HiOutlineMail } from "react-icons/hi";
import { daysJsFormat } from "../../../utils/constants";
import { isFunction } from "webpack-merge/dist/utils";

const { RangePicker } = DatePicker;

const { TextArea } = Input;

export const renderlabel = option => {
  if (option.label === undefined) {
    return option?.value;
  }

  if (typeof option.label === "string" || option.label instanceof String) {
    return option.label;
  }

  if (option.label instanceof Function) {
    return option.label();
  }
};

export const renderInputType = (
  item,
  index,
  form,
  refForm,
  disabled = false,
  onValuesChange,
  superAdmin,
) => {
  const isDisabled = () => {
    if (superAdmin) {
      return false;
    } else {
      return item.disabled || disabled;
    }
  };


  switch (item.type) {
    case "input-currency":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <InputNumber
            onWheel={() => document.activeElement.blur()}
            controls={false}
            formatter={currencyFormatter}
            onChange={item.onChange !== undefined ? item.onChange : () => {}}
            onBlur={e => {
              return currencyFormatter(e.target.value);
            }}
            placeholder={item.label}
            style={{ width: "100%" }}
            disabled={isDisabled()}
            {...item}
          />
        </ColFormItemWrapper>
      );
    case "input-hidden":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Input
            style={{ display: "none" }}
            addonBefore={item.addonBefore}
            addonAfter={item.addonAfter}
            onChange={item.onChange !== undefined ? item.onChange : () => {}}
            defaultValue={""}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
          />
        </ColFormItemWrapper>
      );
    case "input":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Input
            addonBefore={item.addonBefore}
            addonAfter={item.addonAfter}
            onChange={item.onChange !== undefined ? item.onChange : () => {}}
            defaultValue={""}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
          />
        </ColFormItemWrapper>
      );
    case "password":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Input.Password
            onChange={item.onChange !== undefined ? item.onChange : () => {}}
            defaultValue={""}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
          />
        </ColFormItemWrapper>
      );
    case "slider":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Slider
            max={item.max}
            tooltipVisible={item.tooltipVisible}
            min={item.min}
            range={item.range}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
          />
        </ColFormItemWrapper>
      );
    case "textarea":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <TextArea
            placeholder={item.label}
            rows={item.rows ? item.rows : 4}
            disabled={isDisabled()}
          />
        </ColFormItemWrapper>
      );
    case "breakline":
      return <div style={{ width: "100%" }} />;
    case "select-add":
      return <SelectAddItem index={index} item={item} />;
    case "switch":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Switch
            checkedChildren={"oui"}
            unCheckedChildren={"non"}
            defaultChecked={item.value}
            disabled={isDisabled()}
          />
        </ColFormItemWrapper>
      );
    case "range-picker":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <RangePicker
            style={{ width: "100%" }}
            className={"custom-range-picker"}
            format={"DD/MM/YYYY"}
            disabled={isDisabled()}
          />
        </ColFormItemWrapper>
      );
    case "select":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          {propsFromParent => {
            const { filterChildrenList } = propsFromParent;
            return (
              <Select
                defaultValue={item.defaultValue ? item.defaultValue : undefined}
                onClear={item.onClear}
                allowClear={item.allowClear ? true : false}
                showSearch={item.showSearch ? true : false}
                disabled={isDisabled()}
                mode={item.multiple ? "multiple" : "tag"}
                optionFilterProp={"label"}
                // onSelect={(LabeledValue, option) => {}}
                className={item.select === "colorfull" ? "colorfull" : ""}
                popupClassName={item.select === "colorfull" ? "colorfull" : ""}
                placeholder={
                  item.placeholder !== undefined ? item.placeholder : item.label
                }
                options={
                  item?.selectType === "group"
                    ? item.selectContent.filter(filterChildrenList)
                    : undefined
                }
              >
                {item.selectType !== "group"
                  ? item.selectContent.map((option, i) => (
                      <Option
                        label={option?.label}
                        disabled={option?.disabled}
                        key={option?.key || option?.value}
                        value={option?.value || option?.key}
                        color={option?.color}
                      >
                        {renderlabel(option)}
                      </Option>
                    ))
                  : null}
              </Select>
            );
          }}
        </ColFormItemWrapper>
      );
    case "number":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <InputNumber
            onWheel={() => document.activeElement.blur()}
            controls={false}
            placeholder={item.label}
            style={{ width: "100%" }}
            disabled={isDisabled()}
            {...item}
          />
        </ColFormItemWrapper>
      );
    case "date":
      const { picker = "date" } = item;

      let initalValue = "";

      if (typeof item.value === "string" || item.value instanceof String) {
        initalValue = dayjs(item.value);
      } else {
        initalValue = item.value;
      }

      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <DatePicker
            //locale={frFR}
            className={"customform-date"}
            suffixIcon={item.suffixIcon}
            addonAfter={item.addonAfter}
            showTime={{ format: "HH:mm" }}
            onChange={(d, v) => {}}
            format={generalFormatAntd}
            allowClear={item.allowClear !== undefined ? item.allowClear : false}
            value={dayjs()}
            // value={
            //   typeof item.value === 'string' || item.value instanceof String
            //     ? dayjs(item.value)
            //     : item.value
            // }
            //picker={picker}
            style={{ width: "100%" }}
            disabled={isDisabled()}
            // disabledDate={
            //   item.disabledDate
            //     ? item.disabledDate
            //     : () => {
            //         return true;
            //       }
            // }
          />
        </ColFormItemWrapper>
      );
    case "component":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          {item.component({ disabled })}
        </ColFormItemWrapper>
      );
    case "dynamic-select":
      return (
        <SelectFieldAxios
          index={index}
          refForm={refForm}
          updateEndPoint={item.updateEndPoint}
          ready={item.ready}
          itemsCallBack={e => {
            if (item.itemsCallBack !== undefined) {
              item.itemsCallBack(e, form);
            }
          }}
          endPoint={item.endPoint}
          itemCallback={item.itemCallback}
          filterItem={item.filterItem}
          item={item}
          disabled={isDisabled()}
        />
      );
    case "children":
      return item.render();
    case "submit":
      return (
        !isDisabled() && (
          <ColFormItemWrapper item={item} index={index} refForm={refForm}>
            <Button
              type="primary"
              htmlType="submit"
              size={item.size || "large"}
              loading={item.loading === undefined ? false : item.loading}
            >
              {item.label}
            </Button>
          </ColFormItemWrapper>
        )
      );
    case "reset":
      return (
        !isDisabled() && (
          <ColFormItemWrapper item={item} index={index} refForm={refForm}>
            <Button
              style={{ marginTop: "40px" }}
              type="ghost"
              htmlType="reset"
              size={"large"}
              loading={item.loading === undefined ? false : item.loading}
            >
              Remettre à zéro
            </Button>
          </ColFormItemWrapper>
        )
      );
    case "addressForm":
      return (
        <AddressForm
          disabled={isDisabled()}
          form={form}
          item={item}
          index={index}
          refForm={refForm}
          autoCompleteSearch={item.autoCompleteSearch}
          withLocator={item.withLocator}
        />
      );
    case "email":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Input
            addonBefore={<HiOutlineMail />}
            type={"email"}
            onChange={item.onChange !== undefined ? item.onChange : () => {}}
            defaultValue={""}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
          />
        </ColFormItemWrapper>
      );
    case "google-adress":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <AutoCompleteCustom
            item={item}
            refForm={refForm}
            index={index}
            disabled={isDisabled()}
            placeholder={
              item.placeholder !== undefined ? item.placeholder : item.label
            }
            onPlaceSelected={(place, address) => {
              // refForm;
            }}
          />
        </ColFormItemWrapper>
      );
    case "radio":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Radio.Group
            onChange={item.onChange}
            value={item.value}
            className={"customform-radio"}
          >
            <Space
              direction="vertical"
              style={{ marginBottom: 10 }}
              size={"large"}
            >
              {item.radios.map(rad => {
                return (
                  <Radio value={rad.value}>
                    <Space direction="vertical">
                      <span style={{ fontWeight: 700 }}>{rad.label}</span>
                      <span style={{ fontWeight: 400 }}>{rad.description}</span>
                    </Space>
                  </Radio>
                );
              })}
            </Space>
          </Radio.Group>
        </ColFormItemWrapper>
      );
    case "checkbox":
      const { itemDisabled = [] } = item;
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Checkbox.Group
            disabled={isDisabled()}
            onChange={item.onChange}
            value={item.value}
            className={"customform-radio"}
          >
            <Space
              direction="vertical"
              style={{ marginBottom: 10 }}
              size={item?.size ? item.size : "large"}
            >
              {item.checkboxs.map(checkboxItem => {
                return (
                  <Checkbox
                    value={checkboxItem.value}
                    disabled={
                      isDisabled() || itemDisabled.includes(checkboxItem.value)
                    }
                  >
                    <Space direction="vertical">
                      <span style={{ fontWeight: 700 }}>
                        {checkboxItem.label}
                      </span>
                      {checkboxItem.description && (
                        <span style={{ fontWeight: 400 }}>
                          {checkboxItem.description}
                        </span>
                      )}
                    </Space>
                  </Checkbox>
                );
              })}
            </Space>
          </Checkbox.Group>
        </ColFormItemWrapper>
      );
    case "checkbox-bool":
      return (
        <>
          <ColFormItemWrapper item={item} index={index} refForm={refForm}>
            <label
              style={{
                paddingTop: 15,
                display: "inline-block",
              }}
            >
              <Checkbox
                disabled={isDisabled()}
                onChange={e => {
                  form.setFieldValue(item.name, "off");
                }}
                defaultChecked={item.value}
                className={"customform-check.bool"}
              ></Checkbox>
              <span style={{ marginLeft: 10, fontWeight: 700 }}>
                {item.label}
              </span>

              {item.description && (
                <>
                  <br />
                  <span style={{ fontWeight: 400 }}>{item.description}</span>
                </>
              )}
            </label>
          </ColFormItemWrapper>
        </>
      );
    case "radios":
      return (
        <ColFormItemWrapper item={item} index={index} refForm={refForm}>
          <Radio.Group
            disabled={isDisabled()}
            onChange={item.onChange}
            value={item.value}
            className={"customform-radio"}
          >
            <Space
              direction="vertical"
              style={{ marginBottom: 10 }}
              size={item?.size ? item.size : "large"}
            >
              {item.radios.map(rad => {
                return (
                  <Radio
                    value={rad.value}
                    disabled={isDisabled()}
                    optionType={"default"}
                  >
                    <Space direction="vertical">
                      <span style={{ fontWeight: 700 }}>{rad.label}</span>
                      {rad.description && (
                        <span style={{ fontWeight: 400 }}>
                          {rad.description}
                        </span>
                      )}
                    </Space>
                  </Radio>
                );
              })}
            </Space>
          </Radio.Group>
        </ColFormItemWrapper>
      );
  }
};
